export enum GeographicalType {
    CONTINENT = 1,
    COUNTRY = 2,
    STATE = 3,
    CITY = 4,
    DATE = 5,
    PLAN = 6,
    STATUS = 7,
    CREATED_BY = 8,
    EMAIL_VERIFIED = 9,
    ACCOUNT = 10,
    SPECIALITY = 11,
    POSITION = 12,
    LEAD_STATE = 13,
    ADDED_BY=14,
    COMPANY_NAME=15,
    SPEAKER=16,
    ORGANIZATION=17,
    TYPE=18
  }